import { CardDeck } from '../../../app/types';
import { set as Set_1 } from './1';
import { set as Set_2 } from './2';

export const Sets: CardDeck[] = [Set_1, Set_2];
